const languages = {
  en: {
    days: [
      'Mon',
      'Tue',
      'Wed',
      'Thu',
      'Fri',
      'Sat',
      'Sun',
    ],
    months: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    pickers: [
      'Tomorrow',
      'Day after tomorrow',
    ],
    placeholder: {
      date: 'Select a date',
      dateRange: 'Select a date range',
    },
  },
  fr: {
    days: [
      'Lun',
      'Mar',
      'Mer',
      'Jeu',
      'Ven',
      'Sam',
      'Dim',
    ],
    months: [
      'Jan',
      'Fev',
      'Mar',
      'Avr',
      'Mai',
      'Juin',
      'Juil',
      'Aout',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    pickers: [
      'Demain',
      'Après demain',
    ],
    placeholder: {
      date: 'Sélectionnez une date',
      dateRange: 'Sélectionnez une période',
    },
  },
  es: {
    days: [
      'Lun',
      'mar',
      'Mie',
      'Jue',
      'Vie',
      'Sab',
      'Dom',
    ],
    months: [
      'Ene',
      'Feb',
      'Mar',
      'Abr',
      'May',
      'Jun',
      'Jul',
      'Ago',
      'Sep',
      'Oct',
      'Nov',
      'Dic',
    ],
    pickers: [
      'Mañana',
      'Pasado mañana',
    ],
    placeholder: {
      date: 'Seleccionar fecha',
      dateRange: 'Seleccionar un rango de fechas',
    },
  },
  'pt-br': {
    days: [
      'Seg',
      'Ter',
      'Qua',
      'Quin',
      'Sex',
      'Sáb',
      'Dom',
    ],
    months: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Maio',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    pickers: [
      'Amanhã',
      'Depois de amanhã',
    ],
    placeholder: {
      date: 'Selecione uma data',
      dateRange: 'Selecione um período',
    },
  },
  ru: {
    days: [
      'Пн',
      'Вт',
      'Ср',
      'Чт',
      'Пт',
      'Сб',
      'Вс',
    ],
    months: [
      'Янв',
      'Фев',
      'Мар',
      'Апр',
      'Май',
      'Июн',
      'Июл',
      'Авг',
      'Сен',
      'Окт',
      'Ноя',
      'Дек',
    ],
    pickers: [
      'Завтра',
      'Послезавтра',
    ],
    placeholder: {
      date: 'Выберите дату',
      dateRange: 'Выберите период',
    },
  },
  de: {
    days: [
      'Mo',
      'Di',
      'Mi',
      'Do',
      'Fr',
      'Sa',
      'So',
    ],
    months: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember',
    ],
    pickers: [
      'Morgen',
      'Übermorgen',
    ],
    placeholder: {
      date: 'Datum auswählen',
      dateRange: 'Zeitraum auswählen',
    },
  },
  it: {
    days: [
      'Lun',
      'Mar',
      'Mer',
      'Gio',
      'Ven',
      'Sab',
      'Dom',
    ],
    months: [
      'Gen',
      'Feb',
      'Mar',
      'Apr',
      'Mag',
      'Giu',
      'Lug',
      'Ago',
      'Set',
      'Ott',
      'Nov',
      'Dic',
    ],
    pickers: [
      'Domani',
      'Dopodomani',
    ],
    placeholder: {
      date: 'Seleziona una data',
      dateRange: 'Seleziona un intervallo date',
    },
  },
  nl: {
    days: [
      'ma',
      'di',
      'wo',
      'do',
      'vr',
      'za',
      'zo',
    ],
    months: [
      'januari',
      'februari',
      'maart',
      'april',
      'mei',
      'juni',
      'juli',
      'augustus',
      'september',
      'oktober',
      'november',
      'december',
    ],
    pickers: [
      'Morgen',
      'Overmorger',
    ],
    placeholder: {
      date: 'Selecteer datum',
      dateRange: ' Selecteer periode',
    },
  },
  lt: {
    days: [
      'Pr',
      'An',
      'Tr',
      'Ke',
      'Pe',
      'Še',
      'Se',
    ],
    months: [
      'Sau',
      'Vas',
      'Kov',
      'Bal',
      'Geg',
      'Bir',
      'Lie',
      'Rgp',
      'Rgs',
      'Spa',
      'Lap',
      'Gru',
    ],
    pickers: [
      'Rytoj',
      'Poryt',
    ],
    placeholder: {
      date: 'Pasirinkite datą',
      dateRange: 'Pasirinkite laikotarpį',
    },
  },
  lv: {
    days: [
      'Pr',
      'Ot',
      'Tr',
      'Ce',
      'Pk',
      'Se',
      'Sv',
    ],
    months: [
      'Janv',
      'Febr',
      'Marts',
      'Apr',
      'Maijs',
      'Jūn',
      'Jūl',
      'Aug',
      'Sept',
      'Okt',
      'Nov',
      'Dec',
    ],
    pickers: [
      'Rīt',
      'Parīt',
    ],
    placeholder: {
      date: 'Izvēlēties datumu',
      dateRange: 'Izvēlēties periodu',
    },
  },
  se: {
    days: [
      'Tis',
      'Ons',
      'Tors',
      'Fre',
      'Lör',
      'Sön',
      'Mån',
    ],
    months: [
      'Jan',
      'Febr',
      'Mars',
      'April',
      'Maj',
      'Juni',
      'Juli',
      'Aug',
      'Sept',
      'Okt',
      'Nov',
      'Dec',
    ],
    pickers: [
      'Rytoj',
      'Poryt',
    ],
    placeholder: {
      date: 'Pasirinkite datą',
      dateRange: 'Pasirinkite laikotarpį',
    },
  },
  fi: {
    days: [
      'Ma',
      'Ti',
      'Ke',
      'To',
      'Pe',
      'La',
      'Su',
    ],
    months: [
      'Tam',
      'Hel',
      'Maa',
      'Huh',
      'Tou',
      'Kes',
      'Hei',
      'Elo',
      'Syy',
      'Lok',
      'Mar',
      'Jou',
    ],
    pickers: [
      'Huomenna',
      'Ylihuomenna',
    ],
    placeholder: {
      date: 'Valitse Päivämäärä',
      dateRange: 'Valitse Ajanjakso',
    },
  },
  et: {
    days: [
      'E',
      'T',
      'K',
      'N',
      'R',
      'L',
      'P',
    ],
    months: [
      'Jaan',
      'Veebr',
      'Mär',
      'Apr',
      'Mai',
      'Juuni',
      'Juuli',
      'Aug',
      'Sept',
      'Okt',
      'Nov',
      'Dets',
    ],
    pickers: [
      'Homme',
      'Ülehomme',
    ],
    placeholder: {
      date: 'Vali kuupäev',
      dateRange: 'Vali aeg',
    },
  },
};

export default languages;
